export default __webpack_public_path__ + "static/media/bonus-ico.626c0cc6.svg";